import { Order } from '@spa/services/order'
import _ from 'lodash'

export interface ConditionToApplyPoint {
  readonly isSatisfied: boolean

  readonly errorMessages: string[]
}

export const policy = {
  default: ({ orders }: { orders: Order[] }): ConditionToApplyPoint => ConditionListToApplyPoint.valueOf([
    new OrderMustBeSingle(orders),
    new CatalogOrderMustNotExist(orders),
  ]),
}

class ConditionListToApplyPoint implements ConditionToApplyPoint {
  static valueOf(cons: readonly ConditionToApplyPoint[]): ConditionToApplyPoint {
    return new ConditionListToApplyPoint(cons)
  }

  private constructor(private readonly conditions: Readonly<ConditionToApplyPoint[]>) {}

  get isSatisfied(): boolean {
    return this.conditions.every(cons => cons.isSatisfied)
  }

  get errorMessages(): string[] {
    return _.flatMap(
      this.conditions.filter(con => ! con.isSatisfied), con => con.errorMessages
    )
  }
}

/**
 * ポイント適用できるのは、単独注文の場合のみ
 * @see https://github.com/my-color/front/issues/3860#issuecomment-778927965
 */
class OrderMustBeSingle implements ConditionToApplyPoint {
  constructor(private readonly orders: Order[]) {}

  get isSatisfied(): boolean {
    return this.orders.length === 1
  }

  get errorMessages(): string[] {
    return ['発送が複数に分かれる場合、ポイントはご利用いただけません。']
  }
}
export class CatalogOrderMustNotExist implements ConditionToApplyPoint {
  constructor(private readonly orders: Order[]) {}

  get isSatisfied(): boolean {
    return this.orders.every(ord => ord.kind !== 'catalog')
  }

  get errorMessages(): string[] {
    return ['カタログ商品が含まれる場合、ポイントはご利用いただけません。']
  }
}
